import React, { Children, isValidElement } from "react";
import { useAccordionItemState } from "../../context/ComponentesSlots";
import { motion, AnimatePresence } from "framer-motion";
import Label from "./Label";
import { agruparColorPickers } from "./agruparColorPickers";

export const DURACAO_ABERTURA = 0.2;

type Section = {
    label?: React.ReactNode;
    content: React.ReactNode[];
};

const Slot = ({ children }: { children: React.ReactNode }) => {
    const { isOpen } = useAccordionItemState();
    const childrenArray = Children.toArray(children);

    const sections: Section[] = [];
    let current: Section = { content: [] };

    for (const child of childrenArray) {
        const isLabel = isValidElement(child) && child.type === Label;

        if (isLabel) {
            if (current.label || current.content.length) sections.push(current);

            current = { label: child, content: [] };
        } else {
            current.content.push(child);
        }
    }

    if (current.label || current.content.length) sections.push(current);

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ height: 0 }}
                    animate={{ height: "auto" }}
                    exit={{ height: 0 }}
                    transition={{ duration: DURACAO_ABERTURA }}
                    className="select-none overflow-hidden pb-[8px]"
                >
                    <div className="pt-3 px-2 pb-[0px]">
                        <div className="flex flex-col gap-3 [&_.slider-root-empreender]:items-start [&_.slider-root-empreender]:h-[6px] [&_.flex.flex-col.gap-3:last-child_.slider-root-empreender]:h-[18px] [&_.slider-root-empreender_[data-slot=slider-thumb]]:translate-y-[-34%] [&_.select-empreender-lib]:w-full">
                            {sections.map((section, i) => (
                                <div key={i} className="flex flex-col gap-3">
                                    {section.label && (section.label)}
                                    {agruparColorPickers(section.content)}
                                </div>
                            ))}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Slot;
